import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import commonEN from "./assets/translations/en/common.json";
import commonFR from "./assets/translations/fr/common.json";
import sensorEN from "./assets/translations/en/sensor.json";
import sensorFR from "./assets/translations/fr/sensor.json";
import periodicalEn from "./assets/translations/en/periodical.json";
import periodicalFr from "./assets/translations/fr/periodical.json";
import formEn from "./assets/translations/en/form.json";
import formFr from "./assets/translations/fr/form.json";
import frenchFlag from "./assets/images/svg/flag/french.svg";
import englishFlag from "./assets/images/svg/flag/english.svg";
import { ELanguage } from "./models/enums/language";
import AuthService from "./services/auth/AuthService";
import eslTemplateEn from "./assets/translations/en/eslTemplate.json";
import eslTemplateFr from "./assets/translations/fr/eslTemplate.json";
import { enUS, fr } from "date-fns/locale";

export const defaultLanguage = ELanguage.French;

export const resources = {
    en: {
        common: commonEN,
        periodical: periodicalEn,
        sensor: sensorEN,
        form: formEn,
        eslTemplate: eslTemplateEn,
    },
    fr: {
        common: commonFR,
        periodical: periodicalFr,
        sensor: sensorFR,
        form: formFr,
        eslTemplate: eslTemplateFr,
    },
};

export const availableLanguages = Object.keys(resources);

export const flags: Map<string, string> = new Map<string, string>([
    [availableLanguages[0], englishFlag],
    [availableLanguages[1], frenchFlag],
]);

export const eLanguages: Map<string, ELanguage> = new Map<string, ELanguage>([
    [availableLanguages[0], ELanguage.English],
    [availableLanguages[1], ELanguage.French],
]);

export const languages: Map<ELanguage, string> = new Map<ELanguage, string>([
    [ELanguage.English, availableLanguages[0]],
    [ELanguage.French, availableLanguages[1]],
]);

export const dateLocales: Map<string, Locale> = new Map<string, Locale>([
    [availableLanguages[0], enUS],
    [availableLanguages[1], fr],
]);

i18n.use(initReactI18next).init({
    resources,
    defaultNS: "common",
    lng: languages.get(AuthService.user?.language ?? defaultLanguage) ?? "fr",
    fallbackLng: languages.get(defaultLanguage),
    interpolation: {
        escapeValue: false,
    },
});
